<template>
  <div class="index_home">
    <div v-if="contentInfo.content != ''">
      <div class="content_title">
        <div class="title_top">
          <div>
            <img
              src="https://wwp.huijiaoyun.com/Result/static/img/author.aff49ea.png"
              alt=""
            />
          </div>
          <div><span>教育云周刊</span></div>
        </div>
        <p class="title_text">{{ contentInfo.title }}</p>
        <div class="content_see">
          <span>
            <span>{{util.timestampToTime(contentInfo.publishdate)}}</span>
          </span>
          <span>阅读: {{ contentInfo.view_count }} </span>
        </div>
      </div>
      <div class="content_info" v-html="contentInfo.content"></div>
    </div>
    <div class="msg" v-else>
      <img :src="nodataIcon" alt="" />
      <p>没有文字内容</p>
    </div>
  </div>
</template>

<script>
import { getreduce, getreduceview } from "@/api/user/userCenter.js";
import dayjs from "dayjs";
import util from "@/utils/util.js";
export default {
  name: "cityCaseContent",
  props: {},
  data() {
    return {
      nodataIcon: require("@/assets/img/nodata.png"),
      contentInfo: "",
      util
    };
    
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if(this.$route.query.contentInfo=={}){
      this.contentInfo=JSON.parse(window.sessionStorage.getItem('contentInfo'))
      document.title = this.contentInfo.title;
    }else{
      this.contentInfo = this.$route.query.contentInfo; 
      window.sessionStorage.setItem('contentInfo',JSON.stringify(this.$route.query.contentInfo))
      document.title = this.$route.query.contentInfo.title;
    }
  },
  methods: {
    dayjs,
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.index_home {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  padding: 4%;
  .content_title {
    .title_top {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 42px;
      margin-bottom: 10px;
      div {
        img {
          width: 37px;
          height: 37px;
        }
        span {
          margin-left: 10px;
          color: #467db9;
          font-size: 14px;
        }
      }
    }
    .title_text {
      color: #2d3034;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content_see {
      margin: 1% 0;
      margin-bottom: -10px;
      font-size: 14px;
      color: #9b9b9b;
      span {
        margin-right: 2%;
      }
    }
  }
  .msg {
    text-align: center;
    margin-top: 30%;
    img {
      width: 80px;
      height: 90px;
    }
    p {
      font-size: 17px;
      color: #b2b2b2;
    }
  }
}
</style>
